// extracted by mini-css-extract-plugin
export default {"keyValContainer":"key-val-display__keyValContainer___WGHVo"};